import { Toaster } from "@/components/ui/toaster";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";
import NewsletterPopupInvite from "@/components/public/NewsletterPopupInvite";
import RouteAnalytics from "@/components/RouteAnalytics";
import {
  AboutPage,
  AIBoardroomPage,
  AiOperatorsPage,
  AppBuildPage,
  AppRescuePage,
  ContactPage,
  NotFoundPublic,
  PrivacyPage,
  ProjectPlannerPage,
  PublicHome,
  SystemsAuditPage,
  TermsPage,
  VentureEvaluationPage,
  WorkPage,
} from "@/pages/public/PublicPages";

const publicRoutes = [
  { path: "/", element: <PublicHome /> },
  { path: "/ai-boardroom", element: <AIBoardroomPage /> },
  { path: "/ai-operators", element: <AiOperatorsPage /> },
  { path: "/app-build", element: <AppBuildPage /> },
  { path: "/systems-audit", element: <SystemsAuditPage /> },
  { path: "/app-rescue", element: <AppRescuePage /> },
  { path: "/project-planner", element: <ProjectPlannerPage /> },
  { path: "/venture-evaluation", element: <VentureEvaluationPage /> },
  { path: "/work", element: <WorkPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
];

const legacyRedirects = [
  { path: "/assessment", to: "/systems-audit" },
  { path: "/assessment/*", to: "/systems-audit" },
  { path: "/roi-calculator", to: "/systems-audit" },
  { path: "/roi-calculator/*", to: "/systems-audit" },
  { path: "/ai-boardroom/*", to: "/ai-boardroom" },
  { path: "/pricing", to: "/contact" },
  { path: "/pricing/*", to: "/contact" },
  { path: "/privacy-policy", to: "/privacy" },
  { path: "/terms-of-service", to: "/terms" },
];

const blockedLegacySurfaces = [
  "/auth",
  "/auth/*",
  "/dashboard",
  "/dashboard/*",
  "/admin",
  "/admin/*",
  "/boardroom",
  "/boardroom/*",
  "/boardroom-aws",
  "/boardroom-aws/*",
  "/boardroom-test",
  "/boardroom-test/*",
];

const App = () => (
  <ErrorBoundary>
    <Toaster />
    <BrowserRouter>
      <RouteAnalytics />
      <NewsletterPopupInvite />
      <Routes>
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        {legacyRedirects.map((route) => (
          <Route key={route.path} path={route.path} element={<Navigate to={route.to} replace />} />
        ))}

        {blockedLegacySurfaces.map((path) => (
          <Route key={path} path={path} element={<NotFoundPublic />} />
        ))}
        <Route path="*" element={<NotFoundPublic />} />
      </Routes>
    </BrowserRouter>
  </ErrorBoundary>
);

export default App;
